import { History } from "history";

import {
  GET_TEACHERS,
  GET_TEACHERS_ERROR,
  GET_TEACHERS_SUCCESS,
  GetTeachersAction,
  GetTeachersErrorAction,
  GetTeachersSuccessAction,
} from "./actionTypes";
import { PaginateQuery, TeacherDto } from "../../../interfaces";
import { Paginated } from "../../../models";

//#region Get Teachers

export const getTeachers = (
  request: PaginateQuery,
  history: History
): GetTeachersAction => {
  return {
    type: GET_TEACHERS,
    payload: { request, history },
  };
};

export const getTeachersSuccess = (
  response: Paginated<TeacherDto>
): GetTeachersSuccessAction => {
  return {
    type: GET_TEACHERS_SUCCESS,
    payload: response,
  };
};

export const getTeachersError = (error: any): GetTeachersErrorAction => {
  return {
    type: GET_TEACHERS_ERROR,
    payload: error,
  };
};

//#endregion
